/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * A labelled slice of the carrier's shipments with its share of the whole.
 * Used for the freight-profile bands, delivery geography, and service mix.
 *
 * @export
 * @interface PerformanceBreakdown
 */
export interface PerformanceBreakdown {
  /**
   *
   * @type {string}
   * @memberof PerformanceBreakdown
   */
  label: string;
  /**
   *
   * @type {number}
   * @memberof PerformanceBreakdown
   */
  shipmentCount: number;
  /**
   * Share of the cohort, 0 to 1.
   * @type {number}
   * @memberof PerformanceBreakdown
   */
  sharePercentage: number;
}

/**
 * Check if a given object implements the PerformanceBreakdown interface.
 */
export function instanceOfPerformanceBreakdown(
  value: object,
): value is PerformanceBreakdown {
  if (!("label" in value) || value["label"] === undefined) return false;
  if (!("shipmentCount" in value) || value["shipmentCount"] === undefined)
    return false;
  if (!("sharePercentage" in value) || value["sharePercentage"] === undefined)
    return false;
  return true;
}

export function PerformanceBreakdownFromJSON(json: any): PerformanceBreakdown {
  return PerformanceBreakdownFromJSONTyped(json, false);
}

export function PerformanceBreakdownFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerformanceBreakdown {
  if (json == null) {
    return json;
  }
  return {
    label: json["label"],
    shipmentCount: json["shipmentCount"],
    sharePercentage: json["sharePercentage"],
  };
}

export function PerformanceBreakdownToJSON(json: any): PerformanceBreakdown {
  return PerformanceBreakdownToJSONTyped(json, false);
}

export function PerformanceBreakdownToJSONTyped(
  value?: PerformanceBreakdown | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    label: value["label"],
    shipmentCount: value["shipmentCount"],
    sharePercentage: value["sharePercentage"],
  };
}
